import { render } from "./act-select-dashboards.vue?vue&type=template&id=43be1a29&ts=true"
import script from "./act-select-dashboards.ts?vue&type=script&lang=ts&external"
export * from "./act-select-dashboards.ts?vue&type=script&lang=ts&external"

import "./act-select-dashboards.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__